module.exports = __webpack_public_path__ + "static/media/prescription-profile-menu-active.81f73354.svg";